import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard, routeGuard } from './services/authguard.service';
import { QuestionsComponent } from './questions/questions.component'
import { UpgradePlansComponent } from './upgrade-plans/upgrade-plans.component'
import { PagesLoginWithTokenComponent } from './pages-login-with-token-component/pages-login-with-token-component.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SigninComponent } from './signin/signin.component';
import { ChatComponent } from './chat/chat.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'viking', redirectTo: 'viking/login', pathMatch: 'full' },

  { path: 'loginWithToken', component: PagesLoginWithTokenComponent },
  { path: 'viking/loginWithToken', component: PagesLoginWithTokenComponent },

  
  { path: 'login', component: SigninComponent, canActivate: [routeGuard]},
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
  { path: 'dashboard', redirectTo: 'home', pathMatch: 'full' },
  { path: 'questions', component: QuestionsComponent, canActivate: [AuthGuard]},
  { path: 'upgrade-plans', component: UpgradePlansComponent, canActivate: [AuthGuard]},
  { path: 'reset-password', component: ResetPasswordComponent},


  { path: ':client/login', component: SigninComponent, canActivate: [routeGuard]},
  { path: ':client/home', component: HomeComponent, canActivate: [AuthGuard]},
  { path: ':client/dashboard', redirectTo: 'home', pathMatch: 'full' },
  { path: ':client/questions', component: QuestionsComponent, canActivate: [AuthGuard]},
  { path: ':client/upgrade-plans', component: UpgradePlansComponent, canActivate: [AuthGuard]},
  { path: ':client/reset-password', component: ResetPasswordComponent},

  { path: 'chat', component: ChatComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
